module.exports = __webpack_public_path__ + "static/media/ship.b2c79181.svg";